/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TAB = "COMMENTS" | "PROFILE" | "%future added value";
export type TabBarContainerLocal = {
    readonly activeTab: TAB;
    readonly " $refType": "TabBarContainerLocal";
};
export type TabBarContainerLocal$data = TabBarContainerLocal;
export type TabBarContainerLocal$key = {
    readonly " $data"?: TabBarContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBarContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBarContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeTab",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '716ec79c92a60a2350929afb84dad58e';
export default node;
